import RentalsReservation from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import { UseGetBookingEntitiesOptions, useGetBookingEntities } from '@jucy-ui/common';

type UseGetReservationEntitiesOptions = Omit<UseGetBookingEntitiesOptions, 'booking'> & {
    reservation: RentalsReservation;
};
export const useGetReservationEntities = ({ reservation, ...options }: UseGetReservationEntitiesOptions) =>
    useGetBookingEntities({
        booking: {
            reservationReference: reservation.reservationReference,
            fleetCategory: {
                code: reservation.fleetCategory.categoryCode,
                type: reservation.fleetCategory.typeSlug,
                campaignCode: reservation.fleetCategory.categoryCode,
                campaignId: reservation.fleetCategory.campaignId,
            },
            pickUpLocation: reservation.pickUpLocationCode,
            dropOffLocation: reservation.dropOffLocationCode,
        },
        ...options,
    });
